import { render, staticRenderFns } from "./CommonWarningDialog.vue?vue&type=template&id=b6f8656a&"
import script from "./CommonWarningDialog.vue?vue&type=script&lang=js&"
export * from "./CommonWarningDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports